import React,{Component} from 'react';
import AuthHelper from '../../../libraries/auth-helper';
import language from '../../../libraries/label-lang';
import Button from '@material-ui/core/Button';
import {history} from '../../../shared/configure-store';
import {connect} from 'react-redux';
import {RootActions} from '../../../shared/root-action';
import Logo from '../../../images/logo-black.png';
import Image from '../../../images/success.png';
import {toast, ToastContainer} from 'react-toastify';
import {bindActionCreators} from 'redux';
import Copyright from '../../presentational/copyright';

require('dotenv').config();

class CompanySuccess extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            email: '',
        };
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Register Berhasil';

        if(AuthHelper.getProfile()) {
            let email = AuthHelper.getProfile().users ? AuthHelper.getProfile().users.email : '';
            this.setState({
                email: email,
            });
        }
    }

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleGo  = (link) => {

        history.push(link);
    };

    render() {

        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (
            <main className='success'>
                <section className='my-auto'>
                    <div className='container text-center'>
                        <img src={Logo} alt='logo' className='img-logo' />
                        <p className='text-big'>{text.success_heading}! <br />
                            {text.success_company_paragraph}</p>
                        <img src={Image} alt='success' className='pt-3 d-block mx-auto' />
                        <p className='text-center py-4 mb-0'>{text.success_company_detail} <span className='text-blue'>{this.state.email}</span></p>
                        {/*<p className='text-center small-text pb-5'>Tidak mendapat email?<a href='#'>Kirim ulang tautan</a></p>*/}
                        <div className='mt-4 button-small'>
                            <Button
                                variant='contained'
                                onClick={() => this.handleGo('/reservation')}
                                color='primary'
                            >
                                {text.button_back}
                            </Button>
                        </div>
                    </div>
                </section>
                <footer>
                    <p className='text-center absolute-bottom'><Copyright /></p>
                </footer>
                <ToastContainer autoClose={false} />
            </main>
        )
    }
}

const mapStateToProps = (state) => {

    return {

        profile_state: state.profile_state,

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(CompanySuccess);